import { Button, Flex } from "@mantine/core";
import { useUpdateClientPaymentMethodMutation } from "src/generated/graphql";

interface IEditCardProps {
  id: string;
  isPrimary: boolean;
  onComplete: () => void;
  onEditDetails: () => void;
}

const EditCard = ({
  id,
  isPrimary,
  onComplete,
  onEditDetails,
}: IEditCardProps) => {
  const [updateClientPaymentMethod, { loading }] =
    useUpdateClientPaymentMethodMutation({
      onCompleted: () => {
        onComplete();
      },
    });

  const handleUpdate = () => {
    updateClientPaymentMethod({
      variables: {
        id: id,
        data: {
          isPrimary: !isPrimary,
        },
      },
    });
  };
  return (
    <Flex justify={"center"} align={"center"}>
      {!isPrimary ? (
        <Button
          size="sm"
          mx={10}
          onClick={handleUpdate}
          disabled={loading}
          loading={loading}
        >
          Set as Primary
        </Button>
      ) : null}

      <Button
        size="sm"
        mx={10}
        disabled={loading}
        onClick={onEditDetails}
      >{`Edit Card Details`}</Button>
    </Flex>
  );
};

export default EditCard;
